import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { MessagingService } from "../core/messaging/messaging.service";
import { SeverityType } from "../core/messaging/severity-type.enum";

@Component({
  selector: "app-toolbox",
  templateUrl: "./toolbox.component.html",
  styleUrls: ["./toolbox.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolboxComponent implements OnInit, OnDestroy {
  total = 3;
  private pProgress = 0;
  private progressInterval;


  constructor(
    private readonly changeDetection: ChangeDetectorRef,
    private messagingService: MessagingService
  ) { }

  ngOnInit() {
    this.progressInterval = setInterval(this.updatedProgress, 1300);
  }

  ngOnDestroy() {
    clearInterval(this.progressInterval);
  }

  get progress() {
    return this.pProgress;
  }

  private updatedProgress = () => {
    const total = this.total + 1;
    this.pProgress = (this.pProgress + 1) % total;
    this.changeDetection.detectChanges();
  }

  showToastSuccess() {
    this.messagingService.showToast("Success Message", SeverityType.SUCCESS);
  }

  showToastInfo() {
    this.messagingService.showToast("Info Message", SeverityType.INFO);
  }

  showToastWarn() {
    this.messagingService.showToast("Warn Message", SeverityType.WARN);
  }

  showToastError() {
    this.messagingService.showToast("Error Message", SeverityType.ERROR);
  }

  showMessageSuccess() {
    this.messagingService.showMessage("Success Message", SeverityType.SUCCESS);
  }

  showMessageInfo() {
    this.messagingService.showMessage("Info Message", SeverityType.INFO);
  }

  showMessageWarn() {
    this.messagingService.showMessage("Warn Message", SeverityType.WARN);
  }

  showMessageError() {
    this.messagingService.showMessage("Error Message", SeverityType.ERROR);
  }
}
